var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.992 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57716"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0c6972",
    d: "M10.23 1.763A6 6 0 1 0 11.79 7.5h-1.56a4.5 4.5 0 1 1-4.238-6 4.436 4.436 0 0 1 3.165 1.335L6.742 5.25h5.25V0Z",
    "data-name": "Icon material-refresh"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.9059b1607016a64f63fc16f9a09ef625.svg";
export { ForwardRef as ReactComponent };